<template>
    <div>
         <!-- <div class="flex top">
             <el-button type="primary" @click="CacheWarning=!CacheWarning">Cache Recovery</el-button>
         </div> -->
         <el-form  ref="formCache" class="border top padding" :rules="rules" :model="formCache" >
            <div class="color top size flex">
                 Please Enter The Password For Cache Recovery
            </div>
            <el-form-item class="top"  prop="password">
                <el-input type="password" v-model="formCache.password"   placeholder="Please Input a Password"></el-input>
            </el-form-item>
            <el-form-item>
                <div class="flex">
                    <el-button type="primary" @click="onSubmit">Cache Recovery</el-button>
                </div>
            </el-form-item>
         </el-form>
    </div>
</template>
<script>
import {
    cache,
} from "../../api/cache/cache";
export default {
    data() {
        return {
            formCache: {
                password: ""
            },
            rules: {
                password: [
                    {
                        required: true,
                        message: "The password cannot be empty",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    mounted(){},
    methods: {
        onSubmit(){
            this.$refs["formCache"].validate((valid) => {
                if (valid) {
                    this.$confirm("Confirm Data Recovery from database to cache?", "Tips", {
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        type: "warning"
                    }).then(() => {
                        var data={
                            loginRequest:this.formCache.password
                        }
                        cache(data).then(response => {
                            if(response.code){
                                this.$message.error(response.message);
                            }else{
                                this.$message.success('success')
                            }
                            this.formCache.password = ''
                        })
                        .catch(() => {
                            this.formCache.password = ''
                        });
                    }).catch(() => {
//                                this.$message.error("Cancel");
                    });
                } else {
                    return false;
                }
            });


        }
    }
}
</script>
<style>
.flex {
    display: flex;
    justify-content: center;
    align-items: center;
}
.top {
    margin-top: 30px;
}
.color {
    color: #000;
}
.size {
    font-size: 20px;
    font-weight: bold;
}
.border {
    border: solid 1px #dedede;
}
.padding {
    padding: 30px;
}
</style>
